import { AgTechClickEventHandler, AgTechButtonProps, AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons'
import React, { useRef } from 'react'
import { AgTechForm } from '@agtech/web/components/Forms/AgTechForm'
import { useFormContext } from '@agtech/core/forms/AgTechFormContext'
import { useSaleContactDataGetContactDetailsQuery } from '@sales/data/operation/contacts/SaleContactDataQueries'
import { getSaleContactDetailTabPageProps } from '../../pages/SaleContactDetailsTabPage'
import AgTechModernTabPage from '@agtech/web/components/Pages/Tabbed/Flavors/AgTechModernTabPage'
import AgTechQueryLoadingSurface from '@agtech/core/data/queries/AgTechQueryLoadingSurface'
import { SaleContactRemovalButton } from '../../components/buttons/SaleContactButtons'
import ContactMasterDetailViewDialog from '@agtech/web/integrations/contacts/dialogs/ContactMasterDetailViewDialog'
import { getContactFullName } from '@agtech/data/contacts/ContactData'
import { useContactDataWriteContactAction } from '@agtech/data/contacts/ContactDataActions'

const SaleContactMasterDetailDialog = () => {
    return (
        <ContactMasterDetailViewDialog
            contactDetailPage={contact => <SaleContactMasterDetailPage contactId={contact.id} />}
        />
    )
}

const SaleContactMasterDetailPage = (props: { contactId: number }) => {
    const contactDetailsQuery = useSaleContactDataGetContactDetailsQuery(props.contactId);
    const writeContactAction = useContactDataWriteContactAction();
    const submitButton = useRef<{ click: () => Promise<void> }>({ click: async () => {} });

    return (
        <AgTechQueryLoadingSurface query={contactDetailsQuery}>
            {(contactDetails) => {
                const tabProps = getSaleContactDetailTabPageProps({ contactDetails });

                return (
                    <AgTechForm
                        key={contactDetails.contact.id}
                        structure={{ submitButton }}
                        initialFormData={contactDetails.contact}
                        action={{ action: writeContactAction, getActionData: d => d }}
                    >
                        <AgTechModernTabPage
                            title={getContactFullName(contactDetails.contact)}
                            {...tabProps}
                            header={{
                                ...tabProps.header,
                                content: () => (
                                    <div className='column-based gap-x-3 flex'>
                                        <SaleContactSaveButton onSave={() => submitButton.current?.click()} />
                                        <SaleContactRemovalButton
                                            contact={contactDetails.contact}
                                            text='Delete'
                                        />
                                    </div>
                                )
                            }}
                        />
                    </AgTechForm>
                )
            }}
        </AgTechQueryLoadingSurface>
    )
}

const SaleContactSaveButton = (props: { onSave: () => void }) => {
    const { isDirty } = useFormContext();

    return (
        <AgTechButton
            text='Save'
            icon='fas fa-save'
            classes='button-highlight px-4'
            disableIf={!isDirty}
            action={props.onSave}
        />
    )
}

SaleContactMasterDetailDialog.ButtonProps = (props?: AgTechButtonProps) => ({
    text: 'Manage contacts',
    icon: 'fas fa-address-book',
    ...props,
    action: (e: AgTechClickEventHandler) => e.dialogs.openDialog({
        dialog: () => <SaleContactMasterDetailDialog />
    })
})

SaleContactMasterDetailDialog.Button = (props: AgTechButtonProps) => {
    return (
        <AgTechButton {...SaleContactMasterDetailDialog.ButtonProps(props)} />
    )
}

export default SaleContactMasterDetailDialog
